module.exports = __webpack_public_path__ + "static/media/29BDOS7.15b8c3d9.jpg";